import api from "../axiosIntercepture";

export const saveCatalog = async (catalogData) => {
  try {
    const response = await api.post('/ordermanagement/createCatalog', catalogData);
    return response;
  } catch (err) {
    throw err?.response;
  }
};

export const getCatalogList = async (page = 1, limit = 10) => {
  try {
    const response = await api.post('/ordermanagement/getCatalog', { page, limit });
    const result = response.data?.data;
    return {
      data: result?.data || [],
      pagination: result?.pagination || { totalRecords: 0, currentPage: 1, totalPages: 1, limit },
    };
  } catch (err) {
    throw err?.response?.data?.message;
  }
};

export const updateCatalog = async (data, id) => {
  try {
    const response = await api.post(`/ordermanagement/updateCatalog/${id}`, data);
    return response;
  } catch (err) {
    throw err?.response;
  }
};
